import { ModelBase } from "@shoothill/core";
import { ArrayNotEmpty, IsEmail, IsNotEmpty, ValidateIf } from "class-validator";
import { observable } from "mobx";

export class IssueModel extends ModelBase<IssueModel> {
    // #region Defaults

    public static readonly DEFAULT_ISSUEDRAWINGS = [];
    public static readonly DEFAULT_TOEMAILADDRESS = [];
    public static readonly DEFAULT_CCEMAILADDRESS = [];
    public static readonly DEFAULT_NOTES = "";
    public static readonly DEFAULT_ISISSUE = false;

    // #endregion Defaults

    // #region Related Properties
    // #endregion Related Properties

    // #region Properties

    @observable
    @ArrayNotEmpty({ message: "You must select at least one drawing" })
    public issueItems = observable<string>(IssueModel.DEFAULT_ISSUEDRAWINGS);

    @observable
    @IsNotEmpty({ message: "You must select To user(s)" })
    public selectedToProjectDirectoryPersonUsers: string[] = IssueModel.DEFAULT_TOEMAILADDRESS;

    @observable
    @IsNotEmpty({ message: "You must select CC user(s)" })
    public selectedCCProjectDirectoryPersonUsers: string[] = IssueModel.DEFAULT_CCEMAILADDRESS;

    @observable
    public notes: string = IssueModel.DEFAULT_NOTES;

    @observable
    public isIssue: boolean = IssueModel.DEFAULT_ISISSUE;

    // #endregion Properties

    // #region Methods

    fromDto(model: any): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): any {
        return {
            toProjectDirectoryPersonIds: this.selectedToProjectDirectoryPersonUsers === IssueModel.DEFAULT_TOEMAILADDRESS ? null : this.selectedToProjectDirectoryPersonUsers,
            ccProjectDirectoryPersonIds: this.selectedCCProjectDirectoryPersonUsers === IssueModel.DEFAULT_CCEMAILADDRESS ? null : this.selectedCCProjectDirectoryPersonUsers,
            notes: this.notes,
            drawingIds: this.issueItems,
            isIssue: this.isIssue,
        };
    }

    // #endregion Methods
}
